import { render, staticRenderFns } from "./CrowdField.vue?vue&type=template&id=58a8a87e"
import script from "./CrowdField.vue?vue&type=script&lang=js"
export * from "./CrowdField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports